import { Megaphone, GraduationCap, Users, Church, Sprout } from "lucide-react";
import { Reveal } from "@/components/landing/Reveal";

const AUDIENCES = [
  {
    icon: Megaphone,
    title: "Christian influencers & content creators",
    body: "Own your audience on a platform aligned with your message. No ads, no algorithm burying your content, no adjacent content that contradicts it.",
    span: "lg:col-span-3",
  },
  {
    icon: GraduationCap,
    title: "Course creators & teachers",
    body: "Sell or share courses, host cohorts and live teaching, and keep 100% of your revenue — 0% transaction fees.",
    span: "lg:col-span-3",
  },
  {
    icon: Users,
    title: "Small groups & Bible studies",
    body: "A shared space with Scripture built in: group practices, prayer, and a living record of the group's walk together.",
    span: "lg:col-span-2",
  },
  {
    icon: Church,
    title: "Churches & ministries",
    body: "Gather your community inside the Word Amp app on iOS, Android, and web, at a price small ministries can actually afford. Add your own fully branded app as a paid upgrade. Free tier for small communities; larger communities move to a paid subscription.",
    span: "lg:col-span-2",
  },
  {
    icon: Sprout,
    title: "Campus & young adult ministries",
    body: "Built by a young adult ministry leader, for the 18–35 generation actually asking the questions.",
    span: "lg:col-span-2",
  },
];

export const BuiltFor = () => (
  <section id="built-for" className="relative py-16 md:py-24">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <Reveal>
        <p className="text-sm font-semibold uppercase tracking-[0.2em] text-green-dark mb-4">
          Built for
        </p>
        <h2 className="font-serif text-4xl md:text-5xl tracking-tight text-ink max-w-2xl text-balance">
          For The People Doing The Most Disciple-Making.
        </h2>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-6 gap-5">
        {AUDIENCES.map((a, i) => {
          const Icon = a.icon;
          return (
            <Reveal key={a.title} delay={i * 0.08} className={a.span}>
              <div
                data-testid={`audience-card-${i}`}
                className="group h-full bg-paperwhite rounded-3xl border border-ink/5 p-8 md:p-10 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-[transform,box-shadow] duration-500"
              >
                <div className="w-12 h-12 rounded-2xl bg-green/10 flex items-center justify-center mb-6 group-hover:bg-green/20 transition-colors duration-500">
                  <Icon className="w-6 h-6 text-green-dark" strokeWidth={1.75} />
                </div>
                <h3 className="font-serif text-2xl text-ink leading-snug mb-3">
                  {a.title}
                </h3>
                <p className="text-ink/70 leading-relaxed">{a.body}</p>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
